import { useQueryActions } from '~/utilities/query-actions';

export default defineNuxtRouteMiddleware(async (to) => {
  if (Object.keys(to.query).length > 0) return await useQueryActions(to);
});
